module.exports = __webpack_public_path__ + "static/media/ayshow.6b834d2f.jpg";